import axios from "axios";
import { Cookies } from "react-cookie";
import { message } from "antd";
import { Constants } from "./settings";

const _cookies = new Cookies();

axios.defaults.headers.common["fcmToken"] = localStorage["fcmToken"]
  ? localStorage["fcmToken"]
  : "";
axios.defaults.baseURL = Constants.baseUrl;
axios.defaults.headers.common["Authorization"] = `Bearer ${
  _cookies.get("AccessToken") || ""
}`;

const handleError = (error = {}) => {
  console.log(error.errors)
  switch (error.message) {
    case "Unauthenticated.":
      _cookies.remove("AccessToken", {
        path: "/",
        expires: new Date(1900, 1, 1),
        domain: window.location.hostname,
      });
      window.location = "/account/login";
      break;
    default:
      if (Array.isArray(error.errors))
        error.errors.forEach((text) => message.error(text));
      else if (error.message) message.error(error.message);
      break;
  }
};

const upload = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, { headers: { "content-type": "multipart/form-data" } })
      .then((response) => {
        if (response && response.data) {
          if (response.data.status === 1) {
            resolve(response.data);
          } else {
            handleError(response.data);
            reject(response.data);
          }
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

const get = (url) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then((response) => {
        if (response && response.data) {
          resolve(response.data);
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

const post = (url, params = {}, skip) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then((response) => {
        // if (response && response.data) {
        if (response && response.data) {
          if (skip || response.data.status === 1 || response.data.status == "success" || response.status == "success") {
            resolve(response.data);
          } else {
            handleError(response.data);
            reject(response.data);
          }
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

const put = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params)
      .then((response) => {
        if (response && response.data) {
          if (response.data.status === 1 || response.data.status == "success") {
            resolve(response.data);
          } else {
            handleError(response.data);
            reject(response.data);
          }
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

const del = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, params)
      .then((response) => {
        if (response && response.data) {
          if (response.data.status === 1 || response.data.status == "success" || response.data.status == true) {
            resolve(response.data);
          } else {
            handleError(response.data);
            reject(response.data);
          }
        }
      })
      .catch((error) => {
        handleError(error && error.response && error.response.data);
        reject(error && error.response && error.response.data);
      });
  });
};

export default {

  dashboard: {
    
    list: (params = {}) => {
      let src = `api/customer_repair/dashboard/list?q=${params.q || ""}`;

      if (params.page) src = `${src}&page=${params.page}`;
      if (params.type) src = `${src}&type=${params.type}`;

      return get(src);
    },
    
  },

 
  user: {

    me: () => {
      return get("api/customer_repair/user/info");
    },

    getToken: (params = {}) => {
      return post("api/customer_repair/auth/getToken", params, true);
    },
    login: (params = {}) => {
      return post("api/customer_repair/auth/login", params, true);
    },
    logout: (params = {}) => {
      return get("api/customer_repair/user/logout");
    },
  },

 
  reception: {
   
    list: ( params={}) => {
      return post(`api/customer_repair/reception/list`, params, true);
    },
    show: (id) => {
      return get(`api/customer_repair/reception/show/${id}`);
    },
   
  },

 
  diagnosis: {
 
    update: ( id, params={}) => {
      return post(`api/repair/diagnosis/update/${id}`, params, true);
    },
  },


  payment: {
   
    pay: ( params={}) => {
      return post(`api/customer_repair/payment/pay`, params, true);
    },
  
   
  },

};
